import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class HpInformation extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'hp_information.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
